
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2" viewBox="0 0 457 457"><path d="m27.405 0 36.542 410.56 163.882 46.244 165.022-46.244L429.398 0H27.405Zm322.62 133.904h-192.43l4.283 51.676h183.866l-14.273 155.315-102.499 28.26v.287h-1.143l-103.356-28.547-6.28-79.367h49.965l3.711 39.971 55.959 15.126 56.245-15.126 6.283-65.097H115.625l-13.418-152.46h252.392l-4.574 49.962Z" style="fill-rule:nonzero"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    